export default __webpack_public_path__ + "static/media/Mina vänner_inspelningstekniker_mixare.d4709a51.jpeg";